<div class="flex flex-column items-center">
  <img class="profile-pic ba br4 bw2 b--taupe-grey w-90" [src]="imagePath" alt="profile picture" />
  <p class="tc">
    {{ bioBody }} <br />
    <a routerLink="/contact" class="ruby no-underline underline-hover">{{contact}}</a>
  </p>
</div>